var map = {
	"./btc.png": 214,
	"./btcst.png": 215,
	"./btt.png": 216,
	"./default.png": 217,
	"./eth.png": 218,
	"./jst.png": 219,
	"./jstlp.png": 220,
	"./sunold.png": 221,
	"./sunoldlp.png": 222,
	"./trx.png": 223,
	"./tusd.png": 224,
	"./usdj.png": 225,
	"./usdjlp.png": 226,
	"./usdt.png": 227,
	"./usdtlp.png": 228,
	"./wbtt.png": 229,
	"./wbttlp.png": 230,
	"./win.png": 231,
	"./winlp.png": 232
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 447;